import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-drawing-config-view',
  standalone: true,
  templateUrl: './drawing-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawingConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
